import { ChangeDetectorRef, Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { ProcessListener } from '../process.listener';

@Component({
  selector: 'app-process-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.css'],
  providers: [ProcessListener],
})
export class DownloadComponent extends BaseComponent implements OnChanges {
  @Input() downloadCount: any = 0; // Số lượng tiến trình tải
  isAnimating: boolean = false;
  showMinor: boolean = true;
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private processListener: ProcessListener
  ) {
    super(changeDetector, toastr, modalService);
  }
  get isDownloading(): boolean {
    return this.downloadCount > 0;
  }

  async ngOnInit() {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.downloadCount.currentValue) {
      this.downloadCount = changes.downloadCount.currentValue;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/process/download/download.component.ts